import type { DataIndexAttributeRow, DataIndexEventRow } from '@/services/db/data-index/entity';
import type { Source } from '@customerio/hydra-ui-api';

/** The privacy level the backend uses for an attribute someone marked sensitive. */
const SENSITIVE = 1;

/** One row of either browser, in the shape the table reads. */
export type DataIndexTableRow = {
  id: string;
  description: string | null;
  /** Only an attribute can be marked sensitive; an event never is. */
  isSensitive: boolean;
  tagIds: readonly number[];
  sources: readonly Source[];
};

/**
 * One wire row as the table reads it.
 *
 * An attribute's metadata arrives under a different key from an event's, and
 * only an attribute carries a privacy level, so the two shapes are reconciled
 * here rather than at every cell.
 */
export function toTableRow(row: DataIndexAttributeRow | DataIndexEventRow): DataIndexTableRow {
  const metadata = 'metadata_summary' in row ? row.metadata_summary : row.metadata;

  return {
    id: row.id,
    description: metadata?.description ?? null,
    isSensitive: metadata != null && 'privacy_level' in metadata && metadata.privacy_level === SENSITIVE,
    tagIds: metadata?.tag_ids ?? [],
    sources: metadata?.sources ?? [],
  };
}
